import { render, staticRenderFns } from "./play-chart.vue?vue&type=template&id=516957ed&scoped=true"
import script from "./play-chart.vue?vue&type=script&lang=js"
export * from "./play-chart.vue?vue&type=script&lang=js"
import style0 from "./play-chart.vue?vue&type=style&index=0&id=516957ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516957ed",
  null
  
)

export default component.exports